import TDevolucion from "./TDevolucion"
import { obtenerDevolucionesHistorialAction } from "./../../../ducks/devolucionesHistorial"
import { useEffect } from "react"
import { useDispatch } from "react-redux"

const VDevoluciones = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerDevolucionesHistorialAction())
    },[])
    return (
        <div>
            <TDevolucion />
        </div>
    )
}
export default VDevoluciones